/* eslint-disable consistent-return */
/* eslint-disable no-empty */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-duplicates */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Autocomplete as AutoCompleteLab } from "@material-ui/lab";
import {
  Paper,
  TextField,
  Button,
  InputAdornment,
  IconButton,
  Autocomplete,
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import { ThemeProvider } from "@mui/material/styles";
import TextFieldMUI from "@mui/material/TextField";
import InputCommon from "components/inputCommon";
import { format, isValid, parse } from "date-fns";
import { ptBR } from "date-fns/locale";
import React, {
  ChangeEvent,
  ChangeEventHandler,
  useEffect,
  useState,
} from "react";

import { usePlantaoVendas } from "contexts/PlantaoVendasContext";
import { IoMdClose } from "react-icons/io";
import { MdOutlineMail } from "react-icons/md";
import { useListarEmpreendimentos2 } from "services/api/AppWeb_Empreendimento2/empreendimentos2";
import { useListarTiposAtendimentos } from "services/api/AppWeb_TipoAtendimento";
import {
  useBuscarLogradouro,
  useEmpresasVendas,
} from "services/api/DadosComum";
import { useCorretoresEmpresaVendas } from "services/api/DadosComum/corretores-empresa-vendas";
import { useListarOrigensLeads } from "services/api/Mobile_OrigemLead/origens-leads";
import { RootStateOrAny, useSelector } from "react-redux";
import { BeatLoader } from "react-spinners";
import warn from "../../../../../../constants/toast";

import * as IconsSVG from "../../../../../../assets/iconsSVG";
import UserPlus from "../../../../../../assets/images/userplus.png";
import MaterialUI from "../../../../../../material-UI";
import { useCadastrarAtendimento } from "../../../../../../services/api/AppWeb_Atendimento/cadastrar-atendimento";
import { useListarCanaisContatoPDV } from "../../../../../../services/api/Mobile_CanalContato/canais-contato";
import { AuthState } from "../../../../../../store/ducks/auth/types";
import * as MuiStyles from "./muistyles";
import * as Styles from "./styles";
import useDateFormat from "../../../../../../hooks/useDateFormat";
import { converterObjetoParaString } from "../../../../../../hooks/convertObjectToString";
import { useEmpresasVendasPDV } from "../../../../../../services/api/DadosComum/empresas-vendas-pdv";
import { useListarBairrosEmpreendimentos } from "../../../../../../services/api/Mobile_BairroEmpreendimento/bairros-empreendimentos";

interface Props {
  closeModal: any;
  allFields: boolean;
  idCorretor: string | null | undefined;
  refresh: () => void;
  nomeLead: string | null;
}

const CustomPaper = (props: any) => {
  return <Paper sx={{ marginTop: 2 }} {...props} />;
};

const height = 40;
// const labelOffset = -6;

const FormNovoAtendimento = (props: Props) => {
  const { plantaoVendas, codigoCargo2013, supervisorProduto }: any =
    useSelector<RootStateOrAny, AuthState>((state) => state.user);
  const { plantaoVendas: pdvSelected } = usePlantaoVendas();
  const [telefone, setTelefone] = useState("");
  const [email, setEmail] = useState("");
  const [cep, setCep] = useState<any>("");
  const [nome, setNome] = useState<any>("");
  const [date, setDate] = useState<any>(new Date());
  const [time, setTime] = useState<any>(new Date());
  const [canaisContatoList, setCanaisContatoList]: any = useState([]);
  const [canalContatoValue, setCanalContatoValue] = useState<any>(null);
  const { data: dataCanaisContatoResponse } = useListarCanaisContatoPDV({
    queryKey: "canal_contato_pdv",
  });
  const [origemList, setOrigemList]: any = useState([]);
  const [origemValue, setOrigemValue] = useState<any>(null);
  const { data: dataOrigensLeadResponse } = useListarOrigensLeads({
    filtro: false,
  });
  const [tiposAtendimentosList, setTiposAtendimentosList]: any = useState([]);
  const [tiposAtendimentosValue, setTiposAtendimentosValue] =
    useState<any>(null);
  const { data: dataTiposAtendimentosValueResponse } =
    useListarTiposAtendimentos();
  const [produtosList, setProdutosList]: any = useState([]);
  const [produtoValue, setProdutoValue] = useState<any>(null);
  const { data: dataEmpreedimentos2Response, refetch: refetchEmpreedimentos2 } =
    useListarEmpreendimentos2();
  const [bairrosComerciaisList, setBairrosComerciaisList]: any = useState([]);
  const [bairroComercialValue, setBairroComercialValue] = useState<any>(null);
  const { data: dataBairros } = useListarBairrosEmpreendimentos({
    queryKey: "bairros_novo_atendimento",
  });
  const { data: dataLogradouroResponse, refetch: refetchLogradouro } =
    useBuscarLogradouro({ cep });

  const [empresasVendasList, setEmpresasVendasList]: any = useState([]);
  const [empresaVendaValue, setEmpresaVendaValue] = useState<any>(null);
  const [bairroResidencial, setBairroResidencial] = useState("");
  const [bairroComercial, setBairroComercial] = useState("");
  const [outroCorretorIraAtender, setOutroCorretorIraAtender] = useState(false);
  const { data: dataEmpresasVendasResponse } = useEmpresasVendasPDV({
    idPdv: supervisorProduto ? pdvSelected?.value || "" : plantaoVendas?.id,
    queryKey: "empresas_vendas_pdv_novo_atendimento",
  });
  const {
    data: dataCorretoresEmpresasVendasResponse,
    refetch: refetchCorretoresEmpresasVendas,
  } = useCorretoresEmpresaVendas({
    queryKey: `corretores_empresas_novo_atendimento_${
      empresaVendaValue?.value?.id ?? ""
    }`,
    params: converterObjetoParaString({
      idsEmpresasVendas: empresaVendaValue?.value?.id,
    }),
    enabled: !!empresaVendaValue?.value?.id,
  });
  const [corretorOrigemList, setCorretorOrigemList]: any = useState([]);
  const [corretorOrigemValue, setCorretorOrigemValue] = useState<any>(null);
  const [corretorAtendimentoValue, setCorretorAtendimentoValue] =
    useState<any>(null);
  const [nomeCorretorParceiro, setNomeCorretorparceiro] = useState("");
  const [isTouched, setIsTouched] = useState<boolean>(false);
  const [nomeCorretorOrigem, setNomeCorretorOrigem] = useState("");
  useEffect(() => {
    getCanaisContatos();
  }, [dataCanaisContatoResponse]);

  const getCanaisContatos = () => {
    const formattedData: any = [];
    dataCanaisContatoResponse?.data.forEach((item: any) =>
      formattedData.push({
        label: item?.nome,
        value: item?.id,
      })
    );
    setCanaisContatoList(formattedData);
  };

  useEffect(() => {
    getOrigensLeads();
  }, [dataOrigensLeadResponse]);

  const getOrigensLeads = () => {
    const formattedData: any = [];
    dataOrigensLeadResponse?.data.forEach((item: any) =>
      formattedData.push({
        label: item?.nome,
        value: item?.id,
      })
    );
    setOrigemList(formattedData);
  };

  useEffect(() => {
    getTiposAtendimentos();
  }, [dataTiposAtendimentosValueResponse]);

  const getTiposAtendimentos = () => {
    const formattedData: any = [];
    dataTiposAtendimentosValueResponse?.data.forEach((item: any) =>
      formattedData.push({
        label: item?.nome,
        value: item?.id,
      })
    );
    setTiposAtendimentosList(formattedData);
  };

  useEffect(() => {
    getProdutos();
  }, [dataEmpreedimentos2Response]);

  const getProdutos = () => {
    const formattedData: any = [];
    dataEmpreedimentos2Response?.data?.forEach((item: any) =>
      formattedData.push({
        label: item?.nome,
        value: item?.id,
      })
    );
    setProdutosList(formattedData);
  };

  useEffect(() => {
    getBairros();
  }, [dataBairros]);

  const getBairros = () => {
    const formattedData: any = [];
    dataBairros?.data?.forEach((item: any) =>
      formattedData.push({
        label: item?.nome,
        value: item?.id,
      })
    );
    setBairrosComerciaisList(formattedData);
  };

  useEffect(() => {
    getEmpresasVendas();
  }, [dataEmpresasVendasResponse]);

  const getEmpresasVendas = () => {
    const formattedData: any = [];
    dataEmpresasVendasResponse?.data.forEach((item: any) =>
      formattedData.push({
        label: item?.nome,
        value: {
          id: item?.id365,
          empresaCyrela: item?.empresaCyrela,
        },
      })
    );
    setEmpresasVendasList(formattedData);
  };

  useEffect(() => {
    getPlantaoVendas();
    console.log(plantaoVendas);
  }, [plantaoVendas]);

  const getPlantaoVendas = () => {
    if (supervisorProduto) {
      setProdutoValue({
        label: pdvSelected?.nomeEmpreendimento || "",
        value: pdvSelected?.idEmpreendimento || "",
      });
    } else {
      setProdutoValue(
        plantaoVendas?.empreendimentoPDV
          ? {
              label: plantaoVendas?.empreendimentoPDV?.nome,
              value: plantaoVendas?.empreendimentoPDV?.id,
            }
          : null
      );
    }
  };

  const handleCepChange = (event: any) => {
    const { value } = event.target;
    const numericValue = value.replace(/\D/g, "");
    const formattedValue = numericValue.slice(0, 8);
    const maskedValue = formattedValue.replace(/^(\d{5})(\d{3})$/, "$1-$2");
    setCep(maskedValue);
  };

  useEffect(() => {
    if (cep.length > 8) {
      refetchLogradouro();
    } else {
      setBairroResidencial("");
    }
  }, [cep]);

  const handleChangeBairroResidencial: ChangeEventHandler<
    HTMLInputElement | HTMLTextAreaElement
  > = (event: any) => {
    const { value } = event.target; // obter o valor do campo
    setBairroResidencial(value);
  };

  useEffect(() => {
    setBairroResidencial(dataLogradouroResponse?.data?.bairro);
  }, [dataLogradouroResponse]);

  useEffect(() => {
    refetchEmpreedimentos2();
    setBairroResidencial("");
  }, []);

  function arrayToString(arr: any) {
    return arr.map((obj: any) => `idsEmpresasVendas=${obj.value}`).join("&");
  }

  useEffect(() => {
    setCorretorOrigemList([]);
    setCorretorOrigemValue(null);
    setNomeCorretorOrigem("");
    setNomeCorretorparceiro("");
    setOutroCorretorIraAtender(false);
    setCorretorAtendimentoValue(null);

    if (empresaVendaValue !== null) {
      refetchCorretoresEmpresasVendas();
    }
  }, [empresaVendaValue]);

  useEffect(() => {
    getCorretorOrigem();
  }, [dataCorretoresEmpresasVendasResponse]);

  useEffect(() => {
    setCorretorAtendimentoValue(null);
  }, [outroCorretorIraAtender]);

  const getCorretorOrigem = () => {
    const formattedData: any = [];
    dataCorretoresEmpresasVendasResponse?.data.forEach((item: any) =>
      formattedData.push({
        label: item?.nome,
        value: item?.idCorretor,
      })
    );
    setCorretorOrigemList(formattedData);
  };

  const {
    mutate,
    isSuccess,
    isError,
    onError,
    error,
    data: dataResp,
    isLoading: isLoadingCadastro,
  } = useCadastrarAtendimento({
    idLeadCorretor: props.allFields
      ? null
      : props.idCorretor === undefined
      ? null
      : props.idCorretor, // pela busca
    nomeLead: props?.allFields ? nome : props?.nomeLead,
    telefoneLead: props?.allFields ? telefone : null,
    emailLead: props?.allFields ? email : null,
    cepLead: props?.allFields || cep !== "" ? cep : null,
    bairroResidencial:
      props?.allFields || bairroResidencial !== "" ? bairroResidencial : null,
    idBairroComercial:
      props?.allFields || bairroComercialValue !== null
        ? bairroComercialValue?.value
        : null,
    idEmpresaVenda: empresaVendaValue?.value?.id,
    nomeEmpresaVenda: empresaVendaValue?.label,
    idCorretorOrigem: corretorOrigemValue?.value,
    idCorretorAtendimento:
      corretorAtendimentoValue === null
        ? corretorOrigemValue?.value
        : corretorAtendimentoValue?.value,
    nomeCorretorParceiro,
    idEmpreendimento: produtoValue?.value,
    idLocalVenda: supervisorProduto
      ? pdvSelected?.value || ""
      : plantaoVendas?.id, // plantaoVendas?.id
    idCanalSistemaOrigem: canalContatoValue?.value,
    idTipoAtendimento: tiposAtendimentosValue?.value,
    dataHoraVisita:
      isValid(date) && isValid(time)
        ? `${format(date, "yyyy-MM-dd")} ${format(time, "HH:mm:ss")}`
        : null,
    nomeCorretorOrigem: nomeCorretorOrigem !== "" ? nomeCorretorOrigem : null,
  }) as any;

  useEffect(() => {
    if (isSuccess) {
      warn.wargingSuccess(dataResp?.data?.data);
      props.refresh();
      props.closeModal();
    }
  }, [isSuccess, dataResp]);

  const handleSubmit = () => {
    if (isLoadingCadastro) {
      return;
    }
    if (email.length > 0) {
      if (!isEmailValid(email)) {
        return;
      }
    }

    mutate();
  };

  const handleCepOnBlur = () => {
    setBairroResidencial(dataLogradouroResponse?.data?.bairro);

    if (cep.length === 0 || cep.length < 8) {
      setBairroResidencial("");
    }
  };

  useEffect(() => {
    if (empresaVendaValue?.value?.empresaCyrela === true) {
      setNomeCorretorparceiro("");
      setNomeCorretorOrigem("");
    } else {
      setOutroCorretorIraAtender(false);
    }
  }, [empresaVendaValue]);

  function isValidInput(text: string) {
    // Expressão regular para verificar se o texto contém apenas letras e acentos
    const regex = /^[^0-9!@#$%^&*()-=+|\\/?;'"`<>]*$/;
    return regex.test(text);
  }

  const handleChange = (event: any) => {
    const inputValue = event.target.value;
    if (isValidInput(inputValue)) {
      setNome(inputValue);
    }
  };

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (/^[a-zA-Z0-9._@-]*$/.test(e.target.value) || e.target.value === "") {
      setEmail(e.target.value);
    }
  };

  const isEmailValid = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleBlur = () => {
    setIsTouched(true);
  };

  return (
    <Styles.Container>
      <Styles.RowSpace>
        <img src={UserPlus} alt="" />
        <IconButton onClick={() => props.closeModal()}>
          <IoMdClose size={22} />
        </IconButton>
      </Styles.RowSpace>

      <Styles.Space space={20} />
      <Styles.Scroll>
        <Styles.StrongText>Novo atendimento</Styles.StrongText>
        <Styles.Space space={8} />
        <Styles.LightText>
          Cadastre visitas e vincule o corretor responsável pelo lead
        </Styles.LightText>
        <Styles.Space space={37} />
        <Styles.StrongText2>Sobre o atendimento</Styles.StrongText2>
        <Styles.Space space={16} />
        <Grid container spacing={2}>
          <Grid item md={6} xs={12}>
            <Styles.Column>
              <Styles.InputLable>Como tomou conhecimento? *</Styles.InputLable>
              <Autocomplete
                id="combo-box-demo"
                sx={{ backgroundColor: "#fff", border: "none" }}
                options={canaisContatoList}
                value={canalContatoValue}
                onChange={(event: any, value: any) => {
                  setCanalContatoValue(value);
                }}
                autoHighlight
                size="small"
                fullWidth
                PaperComponent={CustomPaper}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    sx={{
                      "& .MuiAutocomplete-inputRoot": {
                        paddingLeft: "8px !important",
                        borderRadius: "8px",
                        height: "40px",
                      },
                    }}
                    placeholder="Como o lead conheceu o produto*"
                  />
                )}
              />
            </Styles.Column>
          </Grid>
          <Grid item md={6} xs={12}>
            <Styles.Column>
              <Styles.InputLable>Tipo *</Styles.InputLable>
              <Autocomplete
                componentsProps={{
                  paper: {
                    sx: {
                      borderRadius: "4px",
                    },
                  },
                }}
                options={tiposAtendimentosList}
                value={tiposAtendimentosValue}
                onChange={(event: any, value: any) => {
                  setTiposAtendimentosValue(value);
                }}
                autoHighlight
                size="small"
                fullWidth
                PaperComponent={CustomPaper}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                renderOption={(props, option) => (
                  <li {...props} key={option.value}>
                    {option.label}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    sx={{
                      "& .MuiAutocomplete-inputRoot": {
                        paddingLeft: "8px !important",
                        borderRadius: "8px",
                        height: "40px",
                      },
                    }}
                    placeholder="Tipo de atendimento"
                  />
                )}
              />
            </Styles.Column>
          </Grid>
        </Grid>
        <Styles.Space space={16} />
        <Styles.Column>
          <Styles.InputLable>Produto de interesse*</Styles.InputLable>
          <Autocomplete
            id="combo-box-demo"
            sx={{ backgroundColor: "#fff", border: "none" }}
            options={produtosList}
            value={produtoValue}
            onChange={(event: any, value: any) => {
              setProdutoValue(value);
            }}
            autoHighlight
            size="small"
            fullWidth
            PaperComponent={CustomPaper}
            isOptionEqualToValue={(option, value) =>
              option.value === value.value
            }
            getOptionLabel={(option) => option.label}
            renderOption={(props, option) => (
              <li {...props} key={option.value}>
                {option.label}
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                sx={{
                  "& .MuiAutocomplete-inputRoot": {
                    paddingLeft: "8px !important",
                    borderRadius: "8px",
                    height: "40px",
                  },
                }}
                placeholder="Produto de interesse*"
              />
            )}
          />
        </Styles.Column>
        <Styles.Space space={16} />
        <Grid container spacing={2}>
          <Grid item md={6} xs={12}>
            <Styles.LocalizationProvider
              locale={ptBR}
              dateAdapter={MaterialUI.AdapterDateFns}
            >
              <Styles.InputLable>Data *</Styles.InputLable>
              <Styles.DesktopDatePicker
                inputFormat="dd/MM/yyyy"
                value={date}
                maxDate={new Date()}
                components={{
                  OpenPickerIcon: IconsSVG.CalendarIcon,
                }}
                InputAdornmentProps={{ position: "start" }}
                onChange={(newValue: any) => setDate(newValue)}
                renderInput={(params: any) => (
                  <Styles.TextField
                    size="small"
                    InputLabelProps={{ shrink: false }}
                    variant="outlined"
                    {...params}
                    label=""
                    placeholder="Data *"
                    fullWidth
                  />
                )}
              />
            </Styles.LocalizationProvider>
          </Grid>
          <Grid item md={6} xs={12}>
            <Styles.LocalizationProvider
              locale={ptBR}
              dateAdapter={MaterialUI.AdapterDateFns}
            >
              <Styles.LabelText>Hora* </Styles.LabelText>
              <Styles.TimePicker
                label="Time"
                value={time}
                onChange={(newValue: any) => setTime(newValue)}
                renderInput={(params: any) => (
                  <Styles.TextField
                    size="small"
                    InputLabelProps={{ shrink: false }}
                    variant="outlined"
                    {...params}
                    label=""
                    placeholder="Hora*"
                    fullWidth
                    required
                  />
                )}
              />
            </Styles.LocalizationProvider>
          </Grid>
        </Grid>
        {!props.allFields ? (
          <>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Styles.TitleAutocomplete style={{ marginTop: 8 }}>
                  CEP
                </Styles.TitleAutocomplete>
                <TextFieldMUI
                  value={cep}
                  onChange={handleCepChange}
                  onBlur={handleCepOnBlur}
                  size="small"
                  variant="outlined"
                  label=""
                  placeholder=""
                  fullWidth
                  style={{ height: 40 }}
                  inputProps={{
                    pattern: "^\\d{5}-\\d{3}$",
                    maxLength: 9,
                    style: {
                      height: 40,
                      padding: "0 16px",
                      borderRadius: 8,
                    },
                  }}
                  InputLabelProps={{
                    style: {
                      height: 40,
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Styles.TitleAutocomplete style={{ marginTop: 8 }}>
                  Bairro Residencial
                </Styles.TitleAutocomplete>
                <TextFieldMUI
                  value={bairroResidencial}
                  onChange={(e) => setBairroResidencial(e.target.value)}
                  size="small"
                  variant="outlined"
                  label=""
                  placeholder=""
                  fullWidth
                  style={{ height: 40 }}
                  inputProps={{
                    style: {
                      height: 40,
                      padding: "0 16px",
                      borderRadius: 8,
                    },
                  }}
                  InputLabelProps={{
                    style: {
                      height: 40,
                    },
                  }}
                />
              </Grid>
            </Grid>
            <Styles.Space space={16} />
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Styles.TitleAutocomplete style={{ marginTop: 8 }}>
                  Bairro Comercial
                </Styles.TitleAutocomplete>
                <Autocomplete
                  id="combo-box-demo"
                  sx={{ backgroundColor: "#fff", border: "none" }}
                  options={dataBairros?.data?.map((item: any) => ({
                    label: item?.nome,
                    value: item?.id,
                  }))}
                  value={bairroComercialValue}
                  onChange={(event: any, value: any) => {
                    setBairroComercialValue(value);
                  }}
                  autoHighlight
                  size="small"
                  fullWidth
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                  getOptionLabel={(option) => option.label}
                  renderOption={(props, option) => (
                    <li {...props} key={option.value}>
                      {option.label}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{
                        "& .MuiAutocomplete-inputRoot": {
                          paddingLeft: "8px !important",
                          height: "40px",
                        },
                      }}
                      placeholder=""
                    />
                  )}
                />
              </Grid>
            </Grid>
          </>
        ) : null}

        <Styles.Space space={16} />
        {props.allFields ? (
          <>
            <Styles.StrongText2>Informações do visitante</Styles.StrongText2>
            <Styles.Space space={16} />
            <Grid item md={12} xs={12}>
              <Styles.Column>
                <Styles.InputLable>Nome *</Styles.InputLable>
                <TextFieldMUI
                  value={nome}
                  onChange={handleChange}
                  size="small"
                  variant="outlined"
                  label=""
                  placeholder=""
                  fullWidth
                  style={{ height }}
                  InputProps={{
                    style: {
                      height,
                      borderRadius: 8,
                    },
                    inputProps: {
                      maxLength: 100,
                    },
                  }}
                  InputLabelProps={{
                    style: {
                      height,
                    },
                  }}
                />
              </Styles.Column>
            </Grid>
            <Styles.Space space={16} />
            <Grid container spacing={2}>
              <Grid item md={6} xs={12}>
                <InputCommon
                  isDisabled={false}
                  type="phone"
                  maxLengthProps={100}
                  label="Telefone"
                  value={telefone}
                  onChange={(event: string) => {
                    setTelefone(event);
                  }}
                  maskValue="(..) .....-...."
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <Styles.Column>
                  <Styles.InputLable>Email</Styles.InputLable>
                  <TextFieldMUI
                    value={email}
                    onChange={handleInputChange}
                    onBlur={() => setIsTouched(true)}
                    onFocus={() => setIsTouched(false)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <IconButton style={{ marginRight: "-20px" }}>
                            <MdOutlineMail />
                          </IconButton>
                        </InputAdornment>
                      ),
                      style: {
                        height,
                        padding: "0",
                        borderRadius: 8,
                      },
                    }}
                    style={{ height }}
                    InputLabelProps={{
                      style: {
                        height,
                      },
                    }}
                    size="small"
                    variant="outlined"
                    label=""
                    placeholder=""
                    fullWidth
                  />
                  {isTouched && !isEmailValid(email) && email.length > 0 && (
                    <Styles.ErrorText>
                      Por favor, digite um email válido.
                    </Styles.ErrorText>
                  )}
                </Styles.Column>
              </Grid>
              <Grid item md={6} xs={12}>
                <Styles.Column>
                  <Styles.InputLable>CEP Residencial</Styles.InputLable>
                  <TextFieldMUI
                    value={cep}
                    onChange={handleCepChange}
                    size="small"
                    variant="outlined"
                    label=""
                    placeholder=""
                    fullWidth
                    style={{ height }}
                    inputProps={{
                      pattern: "^\\d{5}-\\d{3}$",
                      maxLength: 9,
                      style: {
                        height,
                        padding: "0",
                        paddingLeft: 16,
                        borderRadius: 8,
                      },
                    }}
                    InputLabelProps={{
                      style: {
                        height,
                      },
                    }}
                  />
                </Styles.Column>
              </Grid>
              <Grid item md={6} xs={12}>
                <Styles.Column>
                  <Styles.InputLable>Bairro Residencial</Styles.InputLable>
                  <TextFieldMUI
                    value={bairroResidencial}
                    onChange={handleChangeBairroResidencial}
                    size="small"
                    variant="outlined"
                    label=""
                    placeholder=""
                    fullWidth
                    style={{ height }}
                    InputProps={{
                      style: {
                        height,
                        borderRadius: 8,
                      },
                    }}
                    InputLabelProps={{
                      style: {
                        height,
                      },
                    }}
                  />
                </Styles.Column>
              </Grid>
              <Grid item md={6} xs={12}>
                <Styles.Column>
                  <Styles.InputLable>Bairro Comercial</Styles.InputLable>
                  <Autocomplete
                    id="combo-box-demo"
                    sx={{ backgroundColor: "#fff", border: "none" }}
                    options={bairrosComerciaisList}
                    value={bairroComercialValue}
                    onChange={(event: any, value: any) => {
                      setBairroComercialValue(value);
                    }}
                    autoHighlight
                    size="small"
                    fullWidth
                    PaperComponent={CustomPaper}
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                    getOptionLabel={(option) => option.label}
                    renderOption={(props, option) => (
                      <li {...props} key={option.value}>
                        {option.label}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        sx={{
                          "& .MuiAutocomplete-inputRoot": {
                            paddingLeft: "8px !important",
                            borderRadius: "8px",
                            height: "40px",
                          },
                        }}
                        placeholder=""
                      />
                    )}
                  />
                </Styles.Column>
              </Grid>
              <Grid item md={6} xs={12} />
              <Grid item md={6} xs={12} />
            </Grid>
          </>
        ) : null}

        <Grid container spacing={2}>
          <Grid item md={6} xs={12}>
            <Styles.Column>
              <Styles.StrongText2>
                Quem atenderá o visitante?
              </Styles.StrongText2>

              <Styles.InputLable>Empresa de vendas *</Styles.InputLable>
              <Autocomplete
                id="combo-box-demo"
                sx={{ backgroundColor: "#fff", border: "none" }}
                options={empresasVendasList}
                value={empresaVendaValue}
                onChange={(event: any, value: any) => {
                  setEmpresaVendaValue(value);
                }}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                autoHighlight
                size="small"
                fullWidth
                PaperComponent={CustomPaper}
                renderOption={(props, option) => (
                  <li {...props} key={option.value}>
                    {option.label}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    sx={{
                      "& .MuiAutocomplete-inputRoot": {
                        paddingLeft: "8px !important",
                        borderRadius: "8px",
                        height: "40px",
                      },
                    }}
                    placeholder=""
                  />
                )}
              />
              <Styles.Space space={26} />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={outroCorretorIraAtender}
                    onChange={(event) =>
                      setOutroCorretorIraAtender(event.target.checked)
                    }
                  />
                }
                sx={{ color: "#333", fontFamily: "Inter", fontSize: "13px" }}
                label="Outro corretor irá atender o visitante"
              />
            </Styles.Column>
          </Grid>
          <Grid item md={6} xs={12}>
            <Styles.Space space={26} />
            {empresaVendaValue?.value?.empresaCyrela === false ? (
              <>
                <Styles.Column>
                  <Styles.InputLable>Corretor de origem *</Styles.InputLable>
                  <TextFieldMUI
                    value={nomeCorretorOrigem}
                    onChange={(e) => setNomeCorretorOrigem(e.target.value)}
                    size="small"
                    variant="outlined"
                    label=""
                    placeholder=""
                    fullWidth
                    style={{ height }}
                    InputProps={{
                      style: {
                        height,
                        borderRadius: 8,
                        opacity: 1,
                      },
                    }}
                    InputLabelProps={{
                      style: {
                        height,
                      },
                    }}
                  />
                  <Styles.Space space={16} />
                  <Styles.InputLable opacity={!outroCorretorIraAtender}>
                    Corretor de atendimento
                  </Styles.InputLable>
                  <TextFieldMUI
                    disabled={!outroCorretorIraAtender}
                    value={nomeCorretorParceiro}
                    onChange={(e) => setNomeCorretorparceiro(e.target.value)}
                    size="small"
                    variant="outlined"
                    label=""
                    placeholder=""
                    fullWidth
                    style={{ height }}
                    InputProps={{
                      style: {
                        height,
                        borderRadius: 8,
                        opacity: !outroCorretorIraAtender ? 0.3 : 1,
                      },
                    }}
                    InputLabelProps={{
                      style: {
                        height,
                      },
                    }}
                  />
                </Styles.Column>
              </>
            ) : (
              <Styles.Column>
                <Styles.InputLable>Corretor de origem *</Styles.InputLable>
                <Autocomplete
                  id="combo-box-demo"
                  options={corretorOrigemList}
                  value={corretorOrigemValue}
                  onChange={(event: any, value: any) => {
                    setCorretorOrigemValue(value);
                  }}
                  autoHighlight
                  size="small"
                  fullWidth
                  PaperComponent={CustomPaper}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                  renderOption={(props, option) => (
                    <li {...props} key={option.value}>
                      {option.label}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{
                        "& .MuiAutocomplete-inputRoot": {
                          paddingLeft: "8px !important",
                          borderRadius: "8px",
                          height: "40px",
                        },
                      }}
                      placeholder=""
                    />
                  )}
                />
                <Styles.Space space={16} />
                <Styles.InputLable opacity={!outroCorretorIraAtender}>
                  Corretor de atendimento {outroCorretorIraAtender && " *"}
                </Styles.InputLable>

                <Autocomplete
                  id="combo-box-demo"
                  sx={{
                    backgroundColor: "#fff",
                    border: "none",
                    "&.MuiAutocomplete-disabled": {
                      // Adicionar estilos específicos para o estado desabilitado
                      borderColor: "red",
                      opacity: 0.5,
                    },
                  }}
                  disabled={!outroCorretorIraAtender}
                  options={corretorOrigemList}
                  value={corretorAtendimentoValue}
                  onChange={(event: any, value: any) => {
                    setCorretorAtendimentoValue(value);
                  }}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                  autoHighlight
                  size="small"
                  fullWidth
                  PaperComponent={CustomPaper}
                  renderOption={(props, option) => (
                    <li {...props} key={option.value}>
                      {option.label}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder=""
                      sx={{
                        "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline":
                          {
                            borderColor: "#f0f0f0",
                          },
                        "& .MuiInputLabel-root.Mui-disabled": {
                          color: "red",
                        },
                        "& .MuiInputBase-input.Mui-disabled": {
                          color: "red",
                        },
                        "& .MuiAutocomplete-clearIndicator.Mui-disabled": {
                          color: "red",
                        },
                        "& .MuiAutocomplete-inputRoot": {
                          paddingLeft: "8px !important",
                          borderRadius: "8px",
                          height: "40px",
                        },
                      }}
                    />
                  )}
                />
              </Styles.Column>
            )}
          </Grid>
        </Grid>
      </Styles.Scroll>
      <Styles.Space space={16} />
      <Grid container spacing={2}>
        <Grid item md={6} xs={12}>
          <Button
            onClick={() => props.closeModal()}
            style={{
              color: "#333333",
              borderColor: "#A3A3A6",
              backgroundColor: "#ffffff",
              textTransform: "none",
            }}
            variant="outlined"
            fullWidth
          >
            Cancelar
          </Button>
        </Grid>
        <Grid item md={6} xs={12}>
          <Button
            onClick={() => handleSubmit()}
            style={{
              backgroundColor: "#2D5BFF",
              color: "#fff",
              textTransform: "none",
              minHeight: "35px",
            }}
            variant="contained"
            fullWidth
          >
            {isLoadingCadastro ? (
              <BeatLoader color="#fff" size={10} />
            ) : (
              "Salvar"
            )}
          </Button>
        </Grid>
      </Grid>
    </Styles.Container>
  );
};

export default FormNovoAtendimento;
